import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import nl from './nl.json';

// Determine initial language from multiple sources
const getInitialLanguage = () => {
  // 0. check querystring if containers language=
  const urlParams = new URLSearchParams(window.location.search);
  const langParam = urlParams.get('language');
  if (langParam && ['nl', 'en'].includes(langParam)) {
    localStorage.setItem('language', langParam); // store preference
    return langParam;
  }

  // 1. Check localStorage first (user preference)
  const storedLang = localStorage.getItem('language');
  if (storedLang && ['nl', 'en'].includes(storedLang)) {
    return storedLang;
  }

  // 2. Check browser language
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang) {
    const langCode = browserLang.toLowerCase().split('-')[0];
    if (langCode === 'nl') return 'nl';
  }

  // 3. Default to English
  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    // debug: true,
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    pluralSeparator: "_"
  });

export default i18n;